import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function StatusMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.contract.status);
  };

  return (
    <MainMenuItem
      itemTitleString="契約書状況を見る"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default StatusMenuItem;
